import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { Uploads } from '../../../services/uploads';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DeliberyNoteProcessFotoIa } from '../delibery-note-process-foto-ia/delibery-note-process-foto-ia';




/**
 * Generated class for the DeliberyNoteCreateFotoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-create-foto',
  templateUrl: 'delibery-note-create-foto.html',
})
export class DeliberyNoteCreateFotoPage {

  public image_url_delibery_view: Observable<string | null>;
  img_ref: string = null;
  selectedFiles: FileList;
  isImageUploaded: boolean = false;

  constructor(public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public uploadServices: Uploads,
    public http: HttpClient,
    public translate: TranslateService,
    private alertCtrl: AlertController) {
  }

  async selectFile(event) {
    const file = event.target.files.item(0);
    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files; //File selected

      this.selectedFiles = this.globals.RenameFiles(this.selectedFiles, this.globals.restaurant_uid)

      this.img_ref = await this.uploadServices.uploadComplete(this.selectedFiles, 'AlbaranVision') //Upload file to firbase storage
      this.getImageUrl(this.img_ref);//Get url from image uploaded
      this.isImageUploaded = true;
    }
    else {
      alert('invalid format!');
    }
  }

  getImageUrl(image_ref) {
    //Get image url for show . Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.uploadServices.storage.ref(image_ref);
    this.image_url_delibery_view = ref.getDownloadURL();
  }

  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-imagen'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.uploadServices.delete(this.img_ref);
            this.image_url_delibery_view = null;
            this.img_ref = null;
            this.isImageUploaded = false;
          }
        }
      ]
    });
    alert.present();
  }

  getImage(image) {
    const imageParts = image.split('/');
    let url: string;
    if (imageParts.length > 1) {
      if (imageParts.length === 3) {
        url = `https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/${encodeURIComponent(imageParts[0])}%2F${encodeURIComponent(imageParts[1])}%2F${encodeURIComponent(imageParts[imageParts.length - 1])}?alt=media`;
      } else {
        url = `https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/${encodeURIComponent(imageParts[0])}%2F${encodeURIComponent(imageParts[imageParts.length - 1])}?alt=media`;
      }
    } else {
      url = './assets/images/subir_imagen_v2_Mesa_de_trabajo_1_copia_7.png';
    }
    return url;
  }

  async sendMsgSlack() {
    var title = "AI DELIVERY NOTE";
    var section = {
      "type": "section",
      "text": {
        "type": "mrkdwn",
        "text": ":hotel: " + this.globals.restaurant.company +
          "\n :email: " + this.globals.restaurant.email +
          "\n :camera: " + `${this.getImage(this.img_ref)}` + "\n"
      }
    };
    this.globals.sendCustomerMctSlack(title, section);
  }

  SendTextAndDeleteImage() {
    this.sendMsgSlack()
    this.navCtrl.push(DeliberyNoteProcessFotoIa, {
      img_ref: this.img_ref
    });
  }
}





// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-foto/delibery-note-create-foto.ts